var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLayerTransit01 = function SvgLayerTransit01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "layer_transit-01_svg2__a",
    x1: 15.87,
    x2: 115.81,
    y1: 152.48,
    y2: 22.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#layer_transit-01_svg2__a",
    id: "layer_transit-01_svg2__b",
    x1: -2.06,
    x2: 97.88,
    y1: 138.71,
    y2: 8.56
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#layer_transit-01_svg2__a",
    id: "layer_transit-01_svg2__c",
    x1: 11.09,
    x2: 111.03,
    y1: 148.81,
    y2: 18.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#layer_transit-01_svg2__a",
    id: "layer_transit-01_svg2__d",
    x1: 24.77,
    x2: 124.71,
    y1: 159.32,
    y2: 29.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#layer_transit-01_svg2__a",
    id: "layer_transit-01_svg2__e",
    x1: 41.24,
    x2: 141.18,
    y1: 171.96,
    y2: 41.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#layer_transit-01_svg2__a",
    id: "layer_transit-01_svg2__f",
    x1: 51.92,
    x2: 151.86,
    y1: 180.16,
    y2: 50.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#layer_transit-01_svg2__a",
    id: "layer_transit-01_svg2__g",
    x1: 86.76,
    x2: 186.7,
    y1: 206.92,
    y2: 76.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#layer_transit-01_svg2__a",
    id: "layer_transit-01_svg2__h",
    x1: 75.05,
    x2: 174.99,
    y1: 197.92,
    y2: 67.77
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#layer_transit-01_svg2__a",
    id: "layer_transit-01_svg2__i",
    x1: 89.91,
    x2: 189.85,
    y1: 209.33,
    y2: 79.18
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#layer_transit-01_svg2__a",
    id: "layer_transit-01_svg2__j",
    x1: 75.04,
    x2: 174.98,
    y1: 197.92,
    y2: 67.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#layer_transit-01_svg2__a",
    id: "layer_transit-01_svg2__k",
    x1: 105.82,
    x2: 205.76,
    y1: 221.55,
    y2: 91.39
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M100 33.39a4.76 4.76 0 0 0-4.76 4.77v9.52c0 2.63 2.13 4.76 4.76 4.76s4.76-2.13 4.76-4.76v-9.52c0-2.63-2.13-4.77-4.76-4.77",
    style: {
      fill: "url(#layer_transit-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.92 88.89h-4.76c-2.63 0-4.76 2.13-4.76 4.76s2.13 4.76 4.76 4.76h4.76c2.63 0 4.76-2.13 4.76-4.76s-2.13-4.76-4.76-4.76",
    style: {
      fill: "url(#layer_transit-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.36 88.89h-5.84c-2.63 0-4.77 2.13-4.77 4.76s2.13 4.76 4.77 4.76h5.84c2.63 0 4.77-2.13 4.77-4.76s-2.13-4.76-4.77-4.76",
    style: {
      fill: "url(#layer_transit-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.09 90.03a26.4 26.4 0 0 0-7.01-1.13h-.09c-2.59 0-4.71 2.08-4.76 4.67-.04 2.61 2.01 4.77 4.61 4.85 1.52.04 3.04.29 4.5.73 2.53.74 5.17-.72 5.91-3.24.72-2.49-.68-5.11-3.17-5.88Z",
    style: {
      fill: "url(#layer_transit-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.08 105.2a41.5 41.5 0 0 0-3.99-5.25 4.75 4.75 0 0 0-3.55-1.59c-1.13 0-2.26.4-3.17 1.21a4.773 4.773 0 0 0-.38 6.73c1.13 1.27 2.15 2.62 3.08 4.05a4.766 4.766 0 0 0 6.58 1.44 4.774 4.774 0 0 0 1.44-6.58v-.02Z",
    style: {
      fill: "url(#layer_transit-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.6 137.9-38.09-38.09a4.77 4.77 0 0 0-6.74 0c-.89.89-1.39 2.1-1.39 3.36v14.26l-26.98-.14c-.53 0-1.06 0-1.59.02V47.62h14.28a4.77 4.77 0 0 0 4.77-4.77c0-1.26-.5-2.47-1.39-3.36L103.37 1.4a4.78 4.78 0 0 0-3.28-1.4h-.18c-1.19.02-2.37.49-3.27 1.4l-38.1 38.09a4.77 4.77 0 0 0 0 6.74c.89.89 2.11 1.39 3.37 1.39H76.2v22.25c-.54-.01-1.08-.03-1.62-.03l-26.96.15V55.73c0-2.63-2.13-4.77-4.76-4.77-1.26 0-2.48.5-3.37 1.4L1.4 90.46A4.74 4.74 0 0 0 0 93.73v.19c.02 1.19.49 2.37 1.4 3.27l38.09 38.1a4.756 4.756 0 0 0 6.73 0c.89-.89 1.4-2.11 1.4-3.37v-14.31l26.98-.15c.88 0 1.59.71 1.59 1.59v76.19c0 2.63 2.13 4.76 4.76 4.76s4.76-2.13 4.76-4.76V166.5c.02-21.9 17.76-39.65 39.66-39.68l31.74.17h.03a4.76 4.76 0 0 0 4.76-4.77v-7.55l26.6 26.59-26.6 26.6v-7.55c0-2.62-2.12-4.75-4.74-4.77l-31.77-.17c-6.13 0-11.11 4.98-11.11 11.11v28.74c0 2.63 2.13 4.76 4.76 4.76s4.76-2.13 4.76-4.76v-28.74c0-.87.7-1.58 1.57-1.59l27.01.14v14.31a4.76 4.76 0 0 0 8.13 3.36l38.09-38.09a4.74 4.74 0 0 0 1.4-3.27v-.18a4.7 4.7 0 0 0-1.4-3.27Zm-94.2-15.89q-.03-.255-.06-.48a4.775 4.775 0 0 0-5.46-3.95c-2.57.41-4.33 2.82-3.96 5.39.21 1.33.32 2.68.32 4.03 0 .21.02.41.04.62a49.5 49.5 0 0 0-9.57 9.83v-18.39c0-6.14-4.99-11.12-11.14-11.11l-31.75.17a4.76 4.76 0 0 0-4.74 4.76v7.55l-26.6-26.6 26.6-26.6v7.55a4.76 4.76 0 0 0 4.77 4.76h.02s35.54-.03 37.4.24c19.22 2.76 33.76 19.39 33.99 38.78-3.4.79-6.71 1.95-9.87 3.45Zm9.89-79.15v47.13c-.82-1.13-1.71-2.23-2.64-3.29a49.3 49.3 0 0 0-6.89-6.5v-7.12c0-2.63-2.13-4.76-4.76-4.76s-4.76 2.13-4.76 4.76v1.31a49 49 0 0 0-9.52-3.27V42.86c0-2.63-2.13-4.77-4.76-4.77h-7.55l26.6-26.6 26.6 26.6h-7.55a4.76 4.76 0 0 0-4.76 4.77Z",
    style: {
      fill: "url(#layer_transit-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 182.54c-2.63 0-4.76 2.13-4.76 4.76v4.76c0 2.63 2.13 4.76 4.76 4.76s4.76-2.13 4.76-4.76v-4.76c0-2.63-2.13-4.76-4.76-4.76",
    style: {
      fill: "url(#layer_transit-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.9 156.4c-.49-.16-.99-.24-1.48-.24-2 0-3.87 1.27-4.53 3.28a33.8 33.8 0 0 0-1.59 8.27 4.77 4.77 0 0 0 4.45 5.05h.3c2.51 0 4.59-1.96 4.75-4.46.12-2.01.51-3.99 1.14-5.9.82-2.5-.54-5.19-3.04-6.01Z",
    style: {
      fill: "url(#layer_transit-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.79 146.03c2.63 0 4.76-2.13 4.76-4.77s-2.13-4.76-4.76-4.76h-7.23c-2.63 0-4.77 2.13-4.77 4.76s2.13 4.77 4.77 4.77z",
    style: {
      fill: "url(#layer_transit-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.55 149.9c1.68-1.1 3.5-1.99 5.4-2.63a4.76 4.76 0 0 0 3-6.03 4.76 4.76 0 0 0-4.51-3.25c-.5 0-1.01.08-1.52.25h-.02c-2.67.9-5.22 2.14-7.57 3.68-2.21 1.42-2.86 4.37-1.44 6.58s4.37 2.86 6.58 1.44c.03-.02.05-.03.08-.05Z",
    style: {
      fill: "url(#layer_transit-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.08 146.03h4.76c2.63 0 4.77-2.13 4.77-4.77s-2.13-4.76-4.77-4.76h-4.76c-2.63 0-4.76 2.13-4.76 4.76s2.13 4.77 4.76 4.77",
    style: {
      fill: "url(#layer_transit-01_svg2__k)"
    }
  }));
};
export default SvgLayerTransit01;